import { connect } from 'react-redux';
import { removeNotification } from './redux/actionCreators';
import { getNotificationQueue } from './redux/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    queue: getNotificationQueue(state, ownProps.queueName),
}); };
var mapDispatchToProps = {
    removeNotification: removeNotification,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=Notifications.container.js.map